import { render, staticRenderFns } from "./ViewSuitcase.vue?vue&type=template&id=db722480&"
import script from "./ViewSuitcase.vue?vue&type=script&lang=js&"
export * from "./ViewSuitcase.vue?vue&type=script&lang=js&"
import style0 from "./ViewSuitcase.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports